import { createSelector } from "reselect"
import { get } from "lodash"
import { getStartDate as getStartDateFromPeriod, getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"
import { getProfileDate, getProfilePeriod } from "modules/portfolio-root/selectors/dates"

export const getEarliestDate = state => get(state, "global.data.dates.data.model.availability.factorsStartDate")
export const getLatestDate = state => get(state, "global.data.dates.data.model.availability.currentDate")

export const getStartDate = createSelector(
  [getProfilePeriod, getLatestDate, getEarliestDate],
  (period, latestDate, earliestDate) => {
    if (period && period.startDate) {
      return period.startDate
    } else {
      const startDate = getStartDateFromPeriod(latestDate, period)

      if (startDate < earliestDate) {
        return earliestDate
      } else {
        return startDate
      }
    }
  },
)

export const getEndDate = createSelector(
  [getProfilePeriod, getLatestDate],
  (period, latestDate) => {
    if (period && period.endDate) {
      return period.endDate
    } else {
      return latestDate
    }
  },
)

export const getSelectedDate = createSelector(
  [getProfileDate, getStartDate, getEndDate],
  (date, startDate, endDate) => {
    if (date && date >= startDate && date <= endDate) {
      return date
    } else {
      return endDate
    }
  },
)

export const getDatesAdjusted = createSelector(
  [getProfilePeriod, getStartDate, getEndDate, getLatestDate],
  getDatesAdjustedHelper,
)
